var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.hostClass},[(!_vm.unreadNotifications.length)?_c('p',{class:_vm.$style.noNotifications},[_vm._v("\n    You have no unread notifications\n  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.unreadNotifications),function(notification){return _c(_vm.typeToComponent(notification),{key:notification.id,tag:"component",attrs:{"notification":notification}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b32e77bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-components/notifications/components/notifications.vue
// module id = Ao3D
// module chunks = 1